<template>
<div class="px-4 sm:px-6 lg:px-8 bg-gray-800 pt-6">
    <div class="flex flex-col items-center justify-center mb-4">
      <input
        v-model="searchTerm"
        type="text"
        placeholder="Szukaj po tytule, mieście lub ID..."
        class="w-full max-w-xl text-lg rounded-full border border-gray-700 py-3 px-6 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-800 text-gray-100 placeholder-gray-400 mb-2"
      />
      <select
        v-model="premiumFilter"
        class="w-full max-w-xs rounded-full border border-gray-700 py-2 px-4 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-800 text-gray-100"
      >
        <option value="all">Wszystkie</option>
        <option value="premium">Tylko PREMIUM</option>
        <option value="standard">Bez PREMIUM</option>
      </select>
    </div>
    <div class="sm:flex sm:items-center mb-4">
      <div class="sm:flex-auto text-left">
        <h1 class="text-xl font-semibold text-white">
          Locals ({{ filteredDane.length }} / {{ dane.length }})
        </h1>
        <p class="mt-2 text-sm text-gray-400">A list of all the pages with short data.</p>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-4 sm:flex-none">
        <button @click.prevent="open('NewTag')" type="button" class="inline-flex items-center justify-center rounded-full border border-transparent bg-indigo-700 px-6 py-4 text-sm font-bold text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto">+ dodaj lokal</button>
      </div>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-700">
              <thead class="bg-gray-700 ">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6">
                    <a href="#" class="group inline-flex">
                      ID
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.id.ascending" aria-hidden="true" @click="sortBy('id')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.id.ascending" aria-hidden="true" @click="sortBy('id')" />                        </span>
                    </a>
                  </th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6">
                    <a href="#" class="group inline-flex">
                      title
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.title.ascending" aria-hidden="true" @click="sortBy('title')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.title.ascending" aria-hidden="true" @click="sortBy('title')" />                        </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      city
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.city.ascending" aria-hidden="true" @click="sortBy('city')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.city.ascending" aria-hidden="true" @click="sortBy('city')" />                      </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      page ({{ landingPageCount }} / {{ dane.length }})
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.haslandingpage.ascending" aria-hidden="true" @click="sortBy('haslandingpage')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.haslandingpage.ascending" aria-hidden="true" @click="sortBy('haslandingpage')" />
                      </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      ocena
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.rating.ascending" aria-hidden="true" @click="sortBy('rating')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.rating.ascending" aria-hidden="true" @click="sortBy('rating')" />
                      </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      type
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.type.ascending" aria-hidden="true" @click="sortBy('type')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.type.ascending" aria-hidden="true" @click="sortBy('type')" />                        </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      premium
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.premium.ascending" aria-hidden="true" @click="sortBy('premium')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.premium.ascending" aria-hidden="true" @click="sortBy('premium')" />
                      </span>
                    </a>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      Reviews
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.reviews.ascending" aria-hidden="true" @click="sortBy('reviews')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.reviews.ascending" aria-hidden="true" @click="sortBy('reviews')" />
                      </span>
                    </a>
                  </th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-700 bg-gray-800">
    <tr
      v-for="d in filteredDane"
      :key="d.id"
      class="hover:bg-gray-700 transition-colors cursor-pointer"
      :class="{ 'opacity-70': isClosed(d) }"
      @click="goToTag(d.id)"
    >
      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-left text-sm font-medium text-white sm:pl-6">{{ d.id }}</td>
      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-left text-sm font-medium text-white sm:pl-6">
        <div class="flex items-center gap-2">
          <span>{{ d.title }}</span>
          <span
            v-if="isClosed(d)"
            class="inline-flex items-center rounded-full bg-red-900/60 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-red-200 ring-1 ring-red-500/40"
          >
            Closed
          </span>
        </div>
      </td>
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">{{ d.city }}</td>
      <!-- <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">{{ item.author }}</td> -->
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
        <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
          :class="d.haslandingpage ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
        >
          {{ d.haslandingpage ? 'YES' : 'NO' }}
        </span>
      </td>
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">{{ getRatingValue(d) ?? '—' }}</td>
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">{{ parseStringToArray(d.type).join(', ') }}</td>
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
        <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
          :class="isPremium(d) ? 'bg-amber-200 text-amber-900' : 'bg-gray-200 text-gray-800'"
        >
          {{ isPremium(d) ? 'PREMIUM' : 'NO' }}
        </span>
      </td>
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">
        <span v-if="d.reviews && d.reviews.length > 0">
          {{ [...new Set(d.reviews.map(r => r.author))].join(', ') }}
        </span>
        <span v-else-if="d.author">
          {{ parseStringToArray(d.author).join(', ') }}
        </span>
      </td>
      <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        <router-link :to="{ name: 'tag', params: { id: d.id }}" class="text-indigo-500 hover:text-indigo-700" @click.stop>
          Edit<span class="sr-only">, {{ d.tag }}</span>
        </router-link>
      </td>
    </tr>
</tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>






<!-- <template>
  <div>
    <ul>
      <li v-for="item in dane" :key="item.id">{{ item.tag }} {{ item.tagGroup }}  </li>
    </ul>
  </div>
</template> -->

<script setup>

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid'
import { ref, onMounted, reactive, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { apiFetch } from '@/composables/apiClient'

    const router = useRouter()
    const route = useRoute();

    const dane = ref([]);
    const groups = ref([]);

    const sortState = reactive({
      id: { ascending: true },
      title: { ascending: true },
      city: { ascending: true },
      author: { ascending: true },
      videoid: { ascending: true },
      publishedat: { ascending: true },
      haslandingpage: { ascending: true },
      timestamp: { ascending: true },
      ismuala: { ascending: true },
      premium: { ascending: true },
      rating: { ascending: true },
      type: { ascending: true },
      reviews: { ascending: true },
    });



    const parseStringToArray = (str) => {
  if (!str) {
    return [];
  }
  // Jeśli to już jest tablica, zwróć ją bezpośrednio
  if (Array.isArray(str)) {
    return str;
  }
  try {
    // Spróbuj sparsować jako JSON
    const parsed = JSON.parse(str);
    // Upewnij się, że wynik jest tablicą
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch (e) {
    // Jeśli parsowanie JSON nie powiedzie się i jest to string, potraktuj go jako pojedynczy element
    if (typeof str === 'string') {
      return [str];
    }
    // W każdym innym przypadku zwróć pustą tablicę
    return [];
  }
};

const getRatingValue = (item) => {
  const raw = item?.ratingValue ?? item?.ratingvalue ?? item?.rating ?? null;
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }

  const asNumber = Number(raw);
  return Number.isNaN(asNumber) ? String(raw) : asNumber;
};

const isClosed = (item) => String(item?.status ?? '').toLowerCase() === 'closed';
const isPremium = (item) =>
  item?.isPremium === true ||
  item?.isPremium === 1 ||
  item?.ispremium === true ||
  item?.ispremium === 1;

    const sortBy = (key) => {
  // Przełączanie kierunku sortowania dla danej kolumny
  sortState[key].ascending = !sortState[key].ascending;

  // Wykonanie sortowania
  dane.value.sort((a, b) => {
    const valueA =
      key === 'rating'
        ? getRatingValue(a)
        : key === 'premium'
          ? (isPremium(a) ? 1 : 0)
          : a[key];
    const valueB =
      key === 'rating'
        ? getRatingValue(b)
        : key === 'premium'
          ? (isPremium(b) ? 1 : 0)
          : b[key];

    if (valueA === null || valueA === undefined) {
      return sortState[key].ascending ? 1 : -1;
    }
    if (valueB === null || valueB === undefined) {
      return sortState[key].ascending ? -1 : 1;
    }

    if (valueA < valueB) {
      return sortState[key].ascending ? -1 : 1;
    }
    if (valueA > valueB) {
      return sortState[key].ascending ? 1 : -1;
    }
    return 0;
  });
};

    onMounted(async () => {
      try {
        const response = await apiFetch('/api/places/all');
        if (!response.ok) throw new Error('Problem z pobraniem danych');

        const data = await response.json();
        const list = Array.isArray(data?.data) ? data.data : [];
        dane.value = list;

        if (list.length > 0) {
          // Debug: sprawdź wartości publishedAt
          console.log('Sample publishedAt values:', list.slice(0, 3).map(item => ({
            id: item.id,
            publishedat: item.publishedat,
            type: typeof item.publishedat
          })));
        }

        sortBy("id");
      } catch (error) {
        console.error(error);
        dane.value = [];
      }
    });



    const checkDuplicatedContent = (array) => {
    const metaDescriptionMap = {};
    const descriptionMap = {};

    // Mapowanie obiektów według ich wartości metaDescription i description
    array.forEach(obj => {
        if (obj.metaDescription) {
            if (!metaDescriptionMap[obj.metaDescription]) {
                metaDescriptionMap[obj.metaDescription] = [];
            }
            metaDescriptionMap[obj.metaDescription].push(obj);
        }
        if (obj.description) {
            if (!descriptionMap[obj.description]) {
                descriptionMap[obj.description] = [];
            }
            descriptionMap[obj.description].push(obj);
        }
    });

    // Filtrowanie obiektów, które mają powtarzające się wartości metaDescription lub description
    const filteredArray = array.filter(obj => 
        (obj.metaDescription && metaDescriptionMap[obj.metaDescription].length > 1) ||
        (obj.description && descriptionMap[obj.description].length > 1)
    );

    // Sortowanie według metaDescription lub description
    return filteredArray.sort((a, b) => {
        const aValue = a.metaDescription || a.description;
        const bValue = b.metaDescription || b.description;
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
    });
}



const showDuplicated = () => {
  dane.value = checkDuplicatedContent(dane.value)
}


const landingPageCount = computed(() => {
  if (filteredDane.value.length > 0) {
    return filteredDane.value.filter(item => item.haslandingpage).length;
  } else {
    return 0;
  }
});

const searchTerm = ref("");
const premiumFilter = ref("all");
const filteredDane = computed(() => {
  const term = searchTerm.value.toLowerCase();
  return dane.value.filter(item => {
    const titleMatch = item.title && item.title.toLowerCase().includes(term);
    const cityMatch = item.city && item.city.toLowerCase().includes(term);
    const idMatch = item.id && String(item.id).includes(term);

    let authorMatch = false;
    if (item.reviews && item.reviews.length > 0) {
      authorMatch = item.reviews.some(review => review.author && review.author.toLowerCase().includes(term));
    } else if (item.author) {
      const authors = parseStringToArray(item.author);
      authorMatch = authors.some(author => author && author.toLowerCase().includes(term));
    }

    const matchesSearch = !searchTerm.value || titleMatch || cityMatch || idMatch || authorMatch;
    const premiumValue = isPremium(item);
    const matchesPremium =
      premiumFilter.value === "all" ||
      (premiumFilter.value === "premium" && premiumValue) ||
      (premiumFilter.value === "standard" && !premiumValue);

    return matchesSearch && matchesPremium;
  });
});

const open = (name) => {
  console.log(name)
  router.push({ name })
}

const goToTag = (id) => {
  router.push({ name: 'tag', params: { id } });
};


</script>
